import AlertIntegrationAccounts from './AlertIntegrationAccounts'
import DiscoveryAccounts from './DiscoveryAccounts'

export { AlertIntegrationAccounts, DiscoveryAccounts }



// WEBPACK FOOTER //
// ./src/views/integration-accounts/index.js